/* eslint-disable consistent-return */
/* eslint-disable no-console */
import t from './SystemMasters.type';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import * as SystemMasterServices from '../../../services/SystemMaster.services';
import { ERROR_MESSAGE, getApiErrorKey, backendErrorMsg } from '../../../Components/helper';
import i18next from 'i18next';
/**
 * Backend master-usage (category, season) keys whose copy lives in the systemMaster namespace rather than in
 * common.json. Anything absent here keeps the legacy `MASTERS.<key>` lookup.
 */
const MASTER_USAGE_TRANSLATION_KEYS = {
  'BACKEND_SERVER.MASTER.CATEGORY_USED_IN_POM_GROUP': 'systemMaster:CATEGORY_MASTER.USED_IN_POM_GROUP',
  'BACKEND_SERVER.MASTER.CATEGORY_USED_IN_SPEC_TEMPLATE': 'systemMaster:CATEGORY_MASTER.USED_IN_SPEC_TEMPLATE',
  'BACKEND_SERVER.MASTER.CATEGORY_USED_IN_BOM_LIBRARY_GROUP': 'systemMaster:CATEGORY_MASTER.USED_IN_BOM_LIBRARY_GROUP',
  'BACKEND_SERVER.MASTER.CATEGORY_USED_IN_COSTING_TEMPLATE': 'systemMaster:CATEGORY_MASTER.USED_IN_COSTING_TEMPLATE',
  'BACKEND_SERVER.MASTER.SEASON_USED_IN_DEVELOPMENT_ORDER': 'systemMaster:SEASONS_MASTER.USED_IN_DEVELOPMENT_ORDER',
  'BACKEND_SERVER.MASTER.SEASON_USED_IN_RANGE_PLAN': 'systemMaster:SEASONS_MASTER.USED_IN_RANGE_PLAN',
  'BACKEND_SERVER.MASTER.SEASON_USED_IN_COLOUR_GROUP': 'systemMaster:SEASONS_MASTER.USED_IN_COLOUR_GROUP',
  'BACKEND_SERVER.MASTER.SEASON_USED_IN_BOM_LIBRARY_GROUP': 'systemMaster:SEASONS_MASTER.USED_IN_BOM_LIBRARY_GROUP',
  'BACKEND_SERVER.MASTER.SEASON_USED_IN_EXCHANGE_RATE': 'systemMaster:SEASONS_MASTER.USED_IN_EXCHANGE_RATE',
  'BACKEND_SERVER.MASTER.SUBBRAND_USED_IN_GRADINGS_LIBRARY': 'systemMaster:SUB_BRAND_MASTER.USED_IN_GRADINGS_LIBRARY',
  'BACKEND_SERVER.MASTER.SUBBRAND_USED_IN_DEVELOPMENT_ORDER': 'systemMaster:SUB_BRAND_MASTER.USED_IN_DEVELOPMENT_ORDER',
};

export const getBrandDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBrands(params); // API
    await dispatch({
      type: t.GET_ALL_BRANDS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSeasonsDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSeasons(params); // API
    await dispatch({
      type: t.GET_ALL_SEASONS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCategory1Details = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCategory1(params); // API
    await dispatch({
      type: t.GET_ALL_CATEGORY_1,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCategory2Details = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCategory2(params); // API
    await dispatch({
      type: t.GET_ALL_CATEGORY_2,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCategory3Details = (params, fromCat4) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCategory3(params); // API
    await dispatch({
      type: t.GET_ALL_CATEGORY_3,
      payload: { data: res.data, fromCategory4: fromCat4 },
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCategory4Details = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCategory4(params); // API
    await dispatch({
      type: t.GET_ALL_CATEGORY_4,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultipleCatgory = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getMultipleCategories(params); // API
    if (res && res?.code === 200) {
      if (params.categoryType === 3) {
        await dispatch({
          type: t.GET_MULTIPLE_CATEGORY_3,
          payload: res.data,
        });
      } else {
        await dispatch({
          type: t.GET_MULTIPLE_CATEGORY_4,
          payload: res.data,
        });
      }
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLengthsDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllLengths(params); // API
    await dispatch({
      type: t.GET_ALL_LENGTHS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCompositionsDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCompositions(params); // API
    await dispatch({
      type: t.GET_ALL_COMPOSITIONS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMainSampleDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllMainSamples(params); // API
    await dispatch({
      type: t.GET_ALL_MAIN_SAMPLE,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPCTypesDetails = (params, isFromSystemMaster) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllPCTypes(params, isFromSystemMaster); // API
    await dispatch({
      type: t.GET_ALL_PC_TYPE,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getOtherSamplesDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllOtherSamples(params); // API
    await dispatch({
      type: t.GET_ALL_OTHER_SAMPLES,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPOSizeDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllPOSizeMaster(params); // API
    await dispatch({
      type: t.GET_ALL_PO_SIZE_MASTER,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getBOMTypeDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBOMTypes(params); // API
    await dispatch({
      type: t.GET_ALL_BOM_TYPE_MASTER,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getBOMTypeComponentDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBOMComponentTypes(params); // API
    await dispatch({
      type: t.GET_ALL_BOM_SUB_COMPONENT_TYPE_MASTER,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getBOMSubTypeDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBOMSubTypes(params); // API
    if (params?.fromBomCompType) {
      await dispatch({
        type: t.GET_ALL_BOM_COMPONENT_TYPE_MASTER,
        payload: res.data,
      });
    } else {
      await dispatch({
        type: t.GET_ALL_BOM_SUB_TYPE_MASTER,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductStatusDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllProductStatus(params); // API
    await dispatch({
      type: t.GET_ALL_PRODUCT_STATUS_MASTER,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setProductStatus = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setDefaultProductStatus(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAllUnitDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllUnits(params); // API
    if (res.code === 200) {
      await dispatch({
        type: t.GET_ALL_UNIT_MASTER,
        payload: res.data,
      });
      return true;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAllCustomDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCustomAccordian(params); // API
    if (res.code === 200) {
      await dispatch({
        type: t.GET_ALL_CUSTOM_ACCORIAN,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAccorianDetail = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getNewAccorianDetail(); // API
    if (res.code === 200) {
      await dispatch({
        type: t.GET_ACCORDIAN,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const postAccorianDetail = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.postNewAccorianDetail(params); // API
    if (res.code === 200) {
      const msg = params.masterName + transactionMsg(`TEMP.CUSTOM_MASTER.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setActiveInactive = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.activeInactive(data); // API
    if (res.code === 200) {
      const msg = resolveMasterMessage(transactionMsg, res.message, data.masterName);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    } else {
      const msg = transactionMsg(`MASTERS.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (error) {
    toastMasterWriteError(transactionMsg, error);
  }
};

export const deleteFromSystemMasters = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteFromSystemMaster(data); // API
    if (res.code === 200) {
      if (data.title === 'categories') {
        toasterMsg(transactionMsg(res.message), 'success');
      } else if (data.title === 'custom-type') {
        const msg = data.headName + transactionMsg(`MASTERS.${res.message}`);
        toasterMsg(msg, 'success');
      } else {
        const msg = resolveMasterMessage(transactionMsg, res.message, data.masterName);
        toasterMsg(msg, 'success');
      }
    } else if (data.title === 'brands' && res?.code === 400) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (MASTER_USAGE_TRANSLATION_KEYS[res?.data?.errMsg]) {
      toasterMsg(transactionMsg(MASTER_USAGE_TRANSLATION_KEYS[res.data.errMsg]), 'danger');
    } else {
      const msg = transactionMsg(`MASTERS.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (error) {
    toastMasterWriteError(transactionMsg, error);
  }
};

export const saveToSystemMaster = (data, transactionMsg, fromBom) => async () => {
  try {
    const res = await SystemMasterServices.saveRespectiveData(data); // API
    if (res.code === 200) {
      if (data.title === 'mainSamples' || data.title === 'categories' || data.title === 'supplier-type' || data.title === 'packaging-type') {
        toasterMsg(transactionMsg(res.message), 'success');
      } else if (fromBom) {
        if (res?.data?.newEntries && res?.data?.newEntries?.length) {
          const msg = transactionMsg(`MASTERS.${res.message}`);
          toasterMsg(msg, 'success');
        }
        if (res?.data?.existingNames && res?.data?.existingNames?.length) {
          toasterMsg(`Composition ${res?.data?.existingNames.join(', ')} already exists`, 'danger');
        }
      } else {
        const msg = resolveMasterMessage(transactionMsg, res.message, data.masterName);
        toasterMsg(msg, 'success');
      }
      if (res?.data?.pimStatusError?.errorKey === 'STATUS_LOCKED') {
        const productCount = res.data.pimStatusError.productCount || 0;
        const lockedMsg = transactionMsg('systemMaster:PRODUCT_STATUS_MASTER.PIM_STATUS_LOCKED', { count: productCount });
        toasterMsg(lockedMsg || `Cannot change — ${productCount} products in PIM`, 'danger');
      }
    } else if (res.code === 400) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    toastMasterWriteError(transactionMsg, error);
  }
};

export const postAllCustomAccordiantoSystemMaster = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.postAllCustomAccordian(data); // API
    if (res.code === 200) {
      const msg = data.masterName + transactionMsg(`TEMP.CUSTOM_MASTER.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setActiveInactiveCustomAccordian = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.activeInactiveNewAccordian(data); // API
    if (res.code === 200) {
      const msg = data.title + transactionMsg(`TEMP.CUSTOM_MASTER.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleTrackingDetails = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleTracking(); // API
    if (res.code === 200) {
      await dispatch({
        type: t.GET_SAMPLE_TRACKING,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleStatusDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleStatus(params); // API
    await dispatch({
      type: t.GET_SAMPLE_STATUS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSampleTrackingSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setSTSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSampleStatusSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setSSSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getFinalsDetails = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllFinals(data); // API
    await dispatch({
      type: t.GET_ALL_FINISHES,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getCustomAttributeFreeText = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCustomAttribute(data); // API
    if (res?.data) {
      const labels = (res.data || []).filter((item) => !item.lableId);
      const values = (res.data || [])
        .filter((item) => item.lableId)
        .sort((a, b) => (a.keyName || '').localeCompare(b.keyName || '', 'en', { sensitivity: 'base' }));
      const sortedPayload = [...labels, ...values];
      await dispatch({
        type: t.CUSTOM_ATTRIBUTE_LIST,
        payload: sortedPayload,
      });
      return sortedPayload;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setCustomAttributeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setCustAttrSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    toastMasterWriteError(transactionMsg, error);
  }
};

export const getMeasurementDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllMeasurement(params); // API
    await dispatch({
      type: t.GET_MEASUREMENT,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setMeasurementSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setMMSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setPlacementSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setPMSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchExchangeRate = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.fetchExchangeRateService(params); // API
    if (res.code === 200) {
      await dispatch({
        type: t.SET_EXCHANGE_RATE_DATA,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveExhangeRate = (data) => async () => {
  try {
    const res = await SystemMasterServices.saveExhangeRateService(data); // API
    if (res.code === 200) {
      toasterMsg('Exchange rate added successfully', 'success');
    }
    return res.code === 200;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPlacementDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllPlacement(params); // API
    await dispatch({
      type: t.GET_PLACEMENT,
      payload: res.data,
    });
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setMasterAccess = (params) => async () => {
  try {
    await SystemMasterServices.setSysMasterAccess(params); // API
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getuserBrandSDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getUserBrands(params); // API
    await dispatch({
      type: t.GET_USER_BRANDS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getuserCategoriesDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getUserCategories(params); // API
    if (params?.type === 1) {
      await dispatch({
        type: t.GET_USER_CATEGORIES1,
        payload: res.data,
      });
    } else {
      await dispatch({
        type: t.GET_USER_CATEGORIES2,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addPortOfLandingAction = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.addPortOfLandingService(data); // API
    if (res.code === 200) {
      toasterMsg('Port of landing added/updated successfully', 'success');
      dispatch(fetchAllPortoflanding());
    }
    return res.code === 200;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchAllPortoflanding = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.fetchAllPortoflandingService(); // API
    if (res.code === 200) {
      await dispatch({
        type: t.ALL_PORT_OF_LANDING,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deletePortOfLanding = (deleteId, transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.deletePortOfLandingService(deleteId); // API
    if (res.code === 200) {
      if (res.message === 'Port of Landing already referenced') {
        console.log(res.message);
        toasterMsg(transactionMsg(ERROR_MESSAGE), 'danger');
      } else {
        toasterMsg(transactionMsg('Deleted Successfully'), 'success');
      }
      dispatch(fetchAllPortoflanding());
    } else if (res.code === 400) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearMultipleReducer = (array) => async (dispatch) => {
  if (array?.includes('cat_3')) {
    await dispatch({
      type: t.GET_MULTIPLE_CATEGORY_3,
      payload: [],
    });
  }
  if (array?.includes('cat_4')) {
    await dispatch({
      type: t.GET_MULTIPLE_CATEGORY_4,
      payload: [],
    });
  }
};

export const unmountSystemmaster = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_SYSTEM_MASTER,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

// add
export const getCostingStageList = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCostingStage(params); // API
    await dispatch({
      type: t.GET_COSTING_STAGE,
      payload: res.data,
    });
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
// drag
export const updateCostingStageList = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.addCostingStageListItem(data);
    if (res.code === 200 && res?.message) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
// delete
export const deleteCostingStageListItem = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.deleteCostingStageListItem(data);
    if (res.code === 200) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(ts(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
// active

export const setCostingStageSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setCostingStageSeq(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductGroup = (transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getProductGroups();

    if (res.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_GROUP,
        payload: res.data,
      });
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const addProductGroup = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.addProductGroupData(data);

    if (res.code === 200 && res.data) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteProductGroup = (id, ts, req) => async () => {
  try {
    const res = await SystemMasterServices.deleteProductGroup(id, req);
    if (res.code === 200) {
      toasterMsg(ts(`PRODUCTS.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(ts(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setProductGroupSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setGroupSeq(params);
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearCustomAttribute = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CUSTOM_ATTRIBUTE_LIST,
      payload: [],
    });
  } catch (error) {
    console.error(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addDocumentTypeMaster = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.addDocumentTypeData(data);

    if (res.code === 200 && res.data) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchDocumentType = (data, ts) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.fetchDocumentType(data);

    if (res.code === 200) {
      await dispatch({
        type: t.GET_DOCUMENT_TYPE,
        payload: res.data,
      });
    } else {
      toasterMsg(ts(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const deleteDocumentType = (data, ts, req) => async () => {
  try {
    const res = await SystemMasterServices.deleteDocumentType(data, req);
    if (res.code === 200) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(ts(`MASTERS.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setDocumentTypeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setTypeSeq(params);
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductIdentifier = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getProductIdentifier(data);

    if (res.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_IDENTIFIER,
        payload: res.data,
      });
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const addProductIdentifier = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.addProductIdentifierData(data);

    if (res.code === 200 && res.data) {
      toasterMsg(ts(`PRODUCT_IDENTIFIER.${res.message}`), 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteProductIdentifier = (id, ts) => async () => {
  try {
    const res = await SystemMasterServices.deleteProductIdentifier(id);
    if (res.code === 200) {
      toasterMsg(ts(`PRODUCT_IDENTIFIER.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(ts(`PRODUCT_IDENTIFIER.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductIdentifierType = (transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getProductIdentifierChange();
    if (res.code === 200) {
      await dispatch({
        type: t.IDENTIFIER_TYPE,
        payload: res.data,
      });
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const UpdateProductIdentifierType = (transactionMsg, obj) => async () => {
  try {
    const res = await SystemMasterServices.UpdateProductIdentifierType(obj);
    if (res.code === 200) {
      toasterMsg(transactionMsg(`PRODUCT_IDENTIFIER.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`PRODUCT_IDENTIFIER.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setProductIdentifierSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setIdentifierSeq(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setActiveInactiveProductIdentifier = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.activeInactive(data); // API
    if (res.code === 200) {
      const msg = transactionMsg(`PRODUCT_IDENTIFIER.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearRearrangeMaster = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_SYSTEM_MASTER,
    });
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const fetchTestTypeMaster = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getTestTypeMaster(params);
    if (res.code === 200) {
      await dispatch({
        type: t.GET_TEST_TYPE_MASTER,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setTestTypeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setTestTypeSeq(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getDamAttributeFreeText = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllDamAttribute(data); // API
    if (data?.type === 'dropdown') {
      await dispatch({
        type: t.DAM_ATTRIBUTE_DROPDOWN_LIST,
        payload: res.data,
      });
    }

    if (data?.type === 'text') {
      await dispatch({
        type: t.DAM_ATTRIBUTE_TEXT_LIST,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setDamAttributeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setDamAttrSequence(params); // API

    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);

      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);

    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSupplierStatusDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSupplierStatus(params); // API
    await dispatch({
      type: t.GET_SUPPLIER_STATUS,
      payload: res.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearDocumentMaster = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_DOCUMENT_MASTER,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSupplierStatusSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setSupplierStatusSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const AutoIdGenerator = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAutoIdGenerator();
    if (res.code === 200) {
      await dispatch({
        type: t.GET_AUTO_ID_MASTER,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return null;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setAutoActiveInactive = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.activeInactive(data);
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    } else {
      const msg = transactionMsg(`MASTERS.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveToSystemMasterAutoId = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.saveToAutoId(data);
    if (res.code === 200 && res?.message) {
      toasterMsg('Auto ID Generator added/updated successfully', 'success');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addManualDocumentTypeMaster = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.addManualDocumentTypeData(data);

    if (res.code === 200 && res.data) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchManualDocumentType = (data, ts) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.fetchManualDocumentType(data);

    if (res.code === 200) {
      await dispatch({
        type: t.GET_DOCUMENT_TYPE,
        payload: res.data,
      });
    } else {
      toasterMsg(ts(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.error('catch..', err);
    toasterMsg(err, 'danger');
  }
};

export const deleteManualDocumentType = (data, ts, req) => async () => {
  try {
    const res = await SystemMasterServices.deleteManualDocumentType(data, req);
    if (res.code === 200) {
      toasterMsg(ts(`MASTERS.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(ts(`MASTERS.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setManualDocumentTypeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveManualTypeSeq(params);
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductIdentifierCounterValueNumber = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.setProductIdentifierCounterValueNumber();
    console.log('resssss', res);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCTCOUNT_OPTIONS,
        payload: res.data,
      });
    }
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultiCustomAttribute = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getMultiCustomAttribute(data); // API
    if (res?.code === 200) {
      const sortedPayload = (res.data || []).map((attr) => ({
        ...attr,
        values: [...(attr.values || [])].sort((a, b) => (a.keyName || '').localeCompare(b.keyName || '', 'en', { sensitivity: 'base' })),
      }));
      await dispatch({
        type: t.GET_PCP_CUSTOM_ATTRIBUTE,
        payload: sortedPayload,
      });
      return sortedPayload;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getBomCustomAttribute = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBomCustomAttribute(data); // API
    await dispatch({
      type: t.CUSTOM_ATTRIBUTE_BOM_LIST,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveMultiAttribute = (data, t) => async () => {
  try {
    const res = await SystemMasterServices.saveMultiAttribute(data);
    if (res.code === 200 && res?.message) {
      const msg = t(`MULTI_CUSTOM_ATTRIBUTES.${res?.message}`);
      toasterMsg(msg, 'success');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteMultiCustom = (data, ts) => async () => {
  try {
    const res = await SystemMasterServices.deleteMultiCustom(data);
    if (res.code === 200) {
      const msg = ts(`MULTI_CUSTOM_ATTRIBUTES.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = ts(`MULTI_CUSTOM_ATTRIBUTES.${res?.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveToBomSystemMaster = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveBomRespectiveData(data);
    if (res?.code === 200 && res?.message) {
      toasterMsg('Bom Custom Attribute added/updated successfully', 'success');
    } else if (res?.code === 400 && res?.data?.errMsg) {
      const msg = transactionMsg(res.data.errMsg);
      toasterMsg(msg, 'danger');
    } else {
      const msg = transactionMsg(`MASTERS.${res?.message || 'An unexpected error occurred'}`);
      toasterMsg(msg, 'danger');
    }

    return true;
  } catch (error) {
    toasterMsg(error.message || 'An unexpected error occurred', 'danger');
  }
};

export const deleteBomCustomAttribute = (id, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteBomCustomAttributeData(id);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setActiveInactiveMultiCustomAttribute = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.activeInactiveMultiCA(data); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MULTI_CUSTOM_ATTRIBUTES.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    } else {
      const msg = transactionMsg(`MASTERS.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setCustomBomAttributeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setCustBomAttrSequence(params); // API
    if (res.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setMultiCustomAttributeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveMultiAttributeSeq(params);
    if (res.code === 200) {
      const msg = transactionMsg(`MULTI_CUSTOM_ATTRIBUTES.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setBomActiveInactive = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.bomActiveInactive(data); // API
    if (res.code === 200) {
      const msg = transactionMsg(res.message);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const msg = transactionMsg(res?.data?.errMsg);
      toasterMsg(msg, 'danger');
    } else {
      const msg = transactionMsg(res.data.errMsg);
      toasterMsg(msg, 'danger');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const AutoToggle = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.AutoToggleButton(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else if (transactionMsg(res?.data?.errMsg)) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (transactionMsg(res?.message)) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const SaveCustomAttribute = (data, t) => async () => {
  try {
    const res = await SystemMasterServices.SaveCustomAttributeOptions(data);
    if (res.code === 200 && res?.message) {
      const msg = t(`${res?.message}`);
      toasterMsg(msg, 'success');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getTypeBasedCatgeory = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getTypeBasedCatgeory(data);
    if (res.code === 200) {
      await dispatch({
        type: t.FETCH_TYPE_BASED_CATEGORY,
        payload: { data: res.data, categoryType: data.categoryType },
      });
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveLengthAccess = (length, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveLengthAccess(length);
    if (res.code === 200 && res?.message) {
      const msg = resolveMasterMessage(transactionMsg, res.message, length.variableOneName ?? length.masterName);
      toasterMsg(msg, 'success');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLengthAccess = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getLengthAccess();
    await dispatch({
      type: t.GET_LENGTH_ACCESS,
      payload: res.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Loads whether the Leg Length master is referenced by Development Order, Product Identifier,
 * Product Costing, Samples or Purchase Order. Drives the lock on the System Master length toggle.
 * A failed check resolves to "not in use" so a transient API error leaves the toggle usable rather
 * than locking an admin out; switching lengths off only hides columns and is reversible.
 */
export const getLengthInUseStatus = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getLengthInUseStatus();
    await dispatch({
      type: t.GET_LENGTH_IN_USE_STATUS,
      payload: res?.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    await dispatch({
      type: t.GET_LENGTH_IN_USE_STATUS,
      payload: { inUse: false, modules: {} },
    });
  }
};

export const setLicensorAccess = (params) => async () => {
  try {
    await SystemMasterServices.setLicensorAccess(params);
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLicensorAccess = () => async () => {
  try {
    const res = await SystemMasterServices.getLicensorAccess();
    if (res?.code === 200) {
      return res?.data[0];
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLicensorDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllLicensor(params);
    await dispatch({
      type: t.GET_ALL_LICENSOR,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLicenseDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllLicense(params);
    await dispatch({
      type: t.GET_ALL_LICENSE,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLicenseDropdownList = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllLicense(params);
    await dispatch({
      type: t.GET_LICENSE_DROPDOWN_LIST,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearLicenseData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_LICENSE,
      payload: [],
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearLikenessData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_LIKENESS,
      payload: [],
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLikenessDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllLikeness(params);
    await dispatch({
      type: t.GET_ALL_LIKENESS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSubBrandDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSubBrand(params);
    await dispatch({
      type: t.GET_ALL_SUB_BRAND,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getPlacementSubBrandDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getPlacementSubBrand(params);
    await dispatch({
      type: t.GET_ALL_PLACEMENT_SUB_BRAND,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSubBrandAccess = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveSubBrandAccess(params);
    if (res.code === 200 && res?.message) {
      const msg = transactionMsg(`MASTERS.${res?.message}`);
      toasterMsg(msg, 'success');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
    throw error; // Add this to properly handle errors
  }
};

export const getSubBrandAccess = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getSubBrandAccess();
    if (res?.code === 200) {
      dispatch({
        type: t.GET_SUB_BRAND_ACCESS,
        payload: res.data,
      });
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearSubBrandData = () => async (dispatch) => {
  await dispatch({
    type: t.GET_ALL_SUB_BRAND,
    payload: [],
  });
  try {
    await dispatch({
      type: t.GET_ALL_SUB_BRAND,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultiSubBrandDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSubBrand(params);
    await dispatch({
      type: t.GET_MULTI_SUB_BRAND,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getIncotermsDetails = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllIncoterms(data); // API
    await dispatch({
      type: t.GET_ALL_INCOTERMS,
      payload: res.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getActiveIncotermsDetails = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllIncoterms(data); // API
    await dispatch({
      type: t.GET_ACTIVE_INCOTERMS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveIncotermsForLicense = (data, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveIncotermsForLicense(data); // API
    if (res.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCustomAttributeDetail = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getCustomAttributeDetail(params);
    await dispatch({
      type: t.GET_CUSTOM_ATTRIBUTE_DETAIL,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearMultiSubBrandData = () => async (dispatch) => {
  await dispatch({
    type: t.GET_MULTI_SUB_BRAND,
    payload: [],
  });
  try {
    await dispatch({
      type: t.GET_MULTI_SUB_BRAND,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPlacementNames = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getPlacementNames(params);
    await dispatch({
      type: t.GET_PLACEMENT_NAMES,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCatBasedOnPT = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getCatBasedOnPT();
    const value = res?.data;
    await dispatch({
      type: t.GET_CAT_BASED_ON_PT,
      payload: value,
    });
    return value;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getBomCustomAttributes = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getBomCustomAttributes(params); // API
    await dispatch({
      type: t.GET_BOM_SOURCE_CUSTOM_ATTRIBUTE,
      payload: res.data,
    });
    return true;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAllColourGroups = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllColourGroups(params);
    await dispatch({
      type: t.GET_ALL_COLOUR_GROUPS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

// Composition Process Master Actions
export const getCompositionProcessDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCompositionProcesses(params); // API
    await dispatch({
      type: t.GET_COMPOSITION_PROCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveCompositionProcessToSystemMaster = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveCompositionProcessToSystemMaster(params); // API
    if (res && res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to save composition process');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const deleteCompositionProcessFromSystemMasters = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteCompositionProcessFromSystemMasters(params); // API
    if (res && res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const setCompositionProcessActiveInactive = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setCompositionProcessActiveInactive(params); // API
    if (res && res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

// BOM Component Type Master Actions
export const getBomComponentTypeDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllBomComponentTypes(params); // API
    await dispatch({
      type: t.GET_BOM_COMPONENT_TYPE,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveBomComponentTypeToSystemMaster = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveBomComponentTypeToSystemMaster(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to save BOM component type');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const deleteBomComponentTypeFromSystemMasters = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteBomComponentTypeFromSystemMasters(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`MASTERS.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const setBomComponentTypeActiveInactive = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setBomComponentTypeActiveInactive(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to update BOM component type status');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

// Product Type Process Master Actions
export const getProductTypeProcessDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllProductTypeProcesses(params); // API
    await dispatch({
      type: t.GET_PRODUCT_TYPE_PROCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveProductTypeProcessToSystemMaster = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveProductTypeProcessToSystemMaster(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');

      return res;
    }
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const deleteProductTypeProcessFromSystemMasters = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteProductTypeProcessFromSystemMasters(params); // API
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(`MASTERS.${res?.data?.errMsg}`), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setProductTypeProcessActiveInactive = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setProductTypeProcessActiveInactive(params); // API
    if (res && res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to update product type process status');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const clearProductTypeProcessMasterData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_PRODUCT_TYPE_PROCESS,
      payload: [],
    });
    return true;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
  }
};

// Sample Type Group Master Actions
export const getSampleTypeGroupDetails = (params) => {
  return async (dispatch) => {
    try {
      const res = await SystemMasterServices.getAllSampleTypeGroups(params);
      console.log('🚀 ~ SystemMasters.action.js:2032 ~ getSampleTypeGroupDetails ~ res:', res);
      await dispatch({
        type: t.GET_ALL_SAMPLE_TYPE_GROUPS,
        payload: res.data,
      });
      return res.data;
    } catch (error) {
      console.log(error.message);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };
};

export const checkSampleTypeInUse = (params) => async () => {
  try {
    const res = await SystemMasterServices.checkSampleTypeInUse(params);
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in checkSampleTypeInUse:', error);

    throw error;
  }
};

export const checkAutomationConfigInUse = (params) => async () => {
  try {
    const res = await SystemMasterServices.checkAutomationConfigInUse(params);
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in checkAutomationConfigInUse:', error);
    throw error;
  }
};

export const getSampleTypeGroupInUseAttributeValues = (params) => async () => {
  try {
    const res = await SystemMasterServices.getSampleTypeGroupInUseAttributeValues(params);
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in getSampleTypeGroupInUseAttributeValues:', error);
    throw error;
  }
};

export const checkSampleTypeGroupInUse = (params) => async () => {
  try {
    const res = await SystemMasterServices.checkSampleTypeGroupInUse(params);
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in checkSampleTypeGroupInUse:', error);
    throw error;
  }
};

export const saveSampleTypeGroupToSystemMaster = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.saveSampleTypeGroupToSystemMaster(params);
    if (res?.code === 200) {
      return res;
    }
    const errMsg = res?.data?.errMsg ?? res?.data?.data?.errMsg ?? res?.message;
    if (errMsg === 'SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_NAME_IN_USE') {
      toasterMsg(transactionMsg('SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_NAME_IN_USE'), 'danger');
      throw new Error(errMsg);
    }
    throw new Error(res?.message || 'Failed to save sample type group');
  } catch (error) {
    const errMsg = error?.response?.data?.data?.errMsg ?? error?.response?.data?.errMsg ?? error?.message;
    if (error?.message?.includes('SAMPLE_TYPE_GROUP_NAME_EXISTS')) {
      toasterMsg(transactionMsg('SAMPLE_TYPE_GROUP_MASTER.NAME_EXISTS'), 'danger');
    } else if (errMsg === 'SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_NAME_IN_USE') {
      toasterMsg(transactionMsg('SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_NAME_IN_USE'), 'danger');
    } else {
      toasterMsg(errMsg || ERROR_MESSAGE, 'danger');
    }
    throw error;
  }
};

export const deleteSampleTypeGroupFromSystemMasters = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.deleteSampleTypeGroupFromSystemMasters(params);
    const isSuccess = res?.code === 200 || res?.data?.code === 200;
    if (isSuccess) {
      toasterMsg(transactionMsg('SAMPLE_TYPE_GROUP_MASTER.DELETED_SUCCESSFULLY'), 'success');
      return true;
    }
    const errMsg = res?.data?.errMsg ?? res?.data?.data?.errMsg ?? res?.message;
    const displayMsg =
      errMsg === 'SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_GROUP_IN_USE'
        ? transactionMsg('SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_GROUP_IN_USE')
        : errMsg || ERROR_MESSAGE;
    toasterMsg(displayMsg, 'danger');
    return false;
  } catch (error) {
    const errMsg = error?.response?.data?.data?.errMsg ?? error?.response?.data?.errMsg ?? error?.message;
    const displayMsg =
      errMsg === 'SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_GROUP_IN_USE'
        ? transactionMsg('SAMPLE_TYPE_GROUP_MASTER.SAMPLE_TYPE_GROUP_IN_USE')
        : errMsg || ERROR_MESSAGE;
    toasterMsg(displayMsg, 'danger');
    return false;
  }
};

export const setSampleTypeGroupActiveInactive = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.setSampleTypeGroupActiveInactive(params);
    if (res && res?.code === 200) {
      toasterMsg(transactionMsg('SAMPLE_TYPE_GROUP_MASTER.STATUS_UPDATED'), 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to update sample type group status');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const clearSampleTypeGroupMasterData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_SAMPLE_TYPE_GROUPS,
      payload: [],
    });
    return true;
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
  }
};

/**
 * @description Extracts the message from a partner-overview custom attribute failure.
 *
 * NOTE ON SHAPES: the apiClient response interceptor returns `response.data`, so a resolved
 * value here is already the response BODY, the standard `{ code, message, data }` envelope; the
 * payload is at `.data`. Errors reject through axios, where the body is at `error.response.data`
 * and carries the reason in `message`; a `BACKEND_SERVER.*` key is translated.
 */
function resolvePartnerAttributeError(error) {
  const body = error?.response?.data;
  if (typeof body === 'string' && body.trim()) return body;
  const message = body?.message;
  if (typeof message === 'string' && message.startsWith(BACKEND_SERVER_KEY_PREFIX)) {
    return i18next.t(message, { ns: PARTNER_OVERVIEW_NAMESPACE });
  }
  return message ?? ERROR_MESSAGE;
}

export const getPartnerOverviewCustomAttributes = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getPartnerOverviewCustomAttributes(params);
    const attributes = res?.data;
    if (!Array.isArray(attributes)) {
      return null;
    }
    await dispatch({
      type: t.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_LIST,
      payload: attributes,
    });
    return attributes;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPartnerOverviewCustomAttributeUsage = () => async () => {
  try {
    const res = await SystemMasterServices.getPartnerOverviewCustomAttributeUsage();
    const usage = res?.data;
    return typeof usage?.used === 'number' ? usage : null;
  } catch (error) {
    console.log(error.message);
    return null;
  }
};

export const savePartnerOverviewCustomAttributes = (payload) => async () => {
  try {
    const res = await SystemMasterServices.savePartnerOverviewCustomAttributes(payload);
    return { success: true, data: res?.data };
  } catch (error) {
    const message = resolvePartnerAttributeError(error);
    toasterMsg(message, 'danger');
    return { success: false, message };
  }
};

export const updatePartnerOverviewCustomAttribute = (payload) => async () => {
  try {
    const res = await SystemMasterServices.updatePartnerOverviewCustomAttribute(payload);
    return { success: true, data: res?.data };
  } catch (error) {
    const message = resolvePartnerAttributeError(error);
    toasterMsg(message, 'danger');
    return { success: false, message };
  }
};

export const setPartnerOverviewCustomAttributeActiveState = (payload) => async () => {
  try {
    await SystemMasterServices.setPartnerOverviewCustomAttributeActiveState(payload);
    return { success: true };
  } catch (error) {
    const message = resolvePartnerAttributeError(error);
    toasterMsg(message, 'danger');
    return { success: false, message };
  }
};

export const savePartnerOverviewCustomAttributeSequence = (payload) => async () => {
  try {
    await SystemMasterServices.savePartnerOverviewCustomAttributeSequence(payload);
    return { success: true };
  } catch (error) {
    console.log(error.message);
    return { success: false };
  }
};

export const deletePartnerOverviewCustomAttribute = (attributeId) => async () => {
  try {
    await SystemMasterServices.deletePartnerOverviewCustomAttribute(attributeId);
    return { success: true };
  } catch (error) {
    if (error?.response?.status === HTTP_CONFLICT) {
      return { success: false, isInUse: true };
    }
    const message = resolvePartnerAttributeError(error);
    toasterMsg(message, 'danger');
    return { success: false, message };
  }
};

/**
 * @description Fetches the product/component type master without writing it to the shared
 * `pcTypeList` or `pcTypeAdminList` slices. Both are tier-scoped scratch state that sibling
 * masters rendered on the same page populate with their own params, so a consumer needing the
 * unfiltered list keeps it in local component state rather than racing them.
 * @param {object} params The query parameters forwarded to the supplier-type master.
 * @param {boolean} isFromSystemMaster Flags the request as originating from System Masters.
 * @returns {Promise<object[]>} The type list, or an empty array when the request fails.
 */
export const fetchAllPCTypes = (params, isFromSystemMaster) => async () => {
  try {
    const res = await SystemMasterServices.getAllPCTypes(params, isFromSystemMaster);
    return res.data ?? [];
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return [];
  }
};

/*
 * Additional Variables Master — fetch the master list and place it in the store.
 * @param {object} params query parameters forwarded to the service
 * @returns {Function} redux thunk
 */
export const getAdditionalVariablesDetails = (params) => {
  return async (dispatch) => {
    try {
      const res = await SystemMasterServices.getAllAdditionalVariables(params);
      await dispatch({
        type: t.GET_ALL_ADDITIONAL_VARIABLES,
        payload: res.data,
      });
      return res.data;
    } catch (error) {
      console.log(error.message);
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };
};

/**
 * True for the backend's duplicate-config validation keys (name/scope already exists), which the
 * caller shows inline rather than as a generic save failure.
 * @param {string} errMsg - Error message key from the API
 * @returns {boolean}
 */
const isAdditionalVariableDuplicateKey = (errMsg) => !!errMsg?.startsWith?.('ADDITIONAL_VARIABLES_MASTER.') && errMsg.endsWith('_ALREADY_EXISTS');

export const saveAdditionalVariableToSystemMaster = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.saveAdditionalVariableToSystemMaster(params);
    if (res?.code === 200 || res?.code === 201) {
      return res;
    }
    const errMsg = res?.data?.errMsg ?? res?.data?.data?.errMsg ?? res?.message;
    if (isAdditionalVariableDuplicateKey(errMsg)) {
      toasterMsg(transactionMsg(errMsg), 'danger');
      const duplicateError = new Error(errMsg);
      duplicateError.isDuplicate = true;
      throw duplicateError;
    }
    throw new Error(res?.message || 'Failed to save additional variable');
  } catch (error) {
    /* A duplicate we already toasted — surface it to the caller without a second generic message */
    if (error?.isDuplicate) {
      throw error;
    }
    const errMsg = error?.response?.data?.data?.errMsg ?? error?.response?.data?.errMsg ?? error?.message;
    if (isAdditionalVariableDuplicateKey(errMsg)) {
      toasterMsg(transactionMsg(errMsg), 'danger');
      const duplicateError = new Error(errMsg);
      duplicateError.isDuplicate = true;
      throw duplicateError;
    }
    toasterMsg(errMsg || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const getAdditionalVariableInUseStatus = (params) => async () => {
  try {
    const res = await SystemMasterServices.getAdditionalVariableInUseStatus(params);
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in getAdditionalVariableInUseStatus:', error);
    throw error;
  }
};

export const deleteAdditionalVariableFromSystemMasters = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.deleteAdditionalVariableFromSystemMasters(params);
    const isSuccess = res?.code === 200 || res?.data?.code === 200;
    if (isSuccess) {
      toasterMsg(transactionMsg('ADDITIONAL_VARIABLES_MASTER.DELETED_SUCCESSFULLY'), 'success');
      return true;
    }
    const errMsg = res?.data?.errMsg ?? res?.data?.data?.errMsg ?? res?.message;
    /* Translate the in-use guard key; otherwise surface the raw message */
    const displayMsg = errMsg === 'ADDITIONAL_VARIABLES_MASTER.VARIABLE_IN_USE' ? transactionMsg(errMsg) : errMsg;
    toasterMsg(displayMsg || ERROR_MESSAGE, 'danger');
    return false;
  } catch (error) {
    const errMsg = error?.response?.data?.data?.errMsg ?? error?.response?.data?.errMsg ?? error?.message;
    const displayMsg = errMsg === 'ADDITIONAL_VARIABLES_MASTER.VARIABLE_IN_USE' ? transactionMsg(errMsg) : errMsg;
    toasterMsg(displayMsg || ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const setAdditionalVariableActiveInactive = (params, transactionMsg) => async () => {
  try {
    const res = await SystemMasterServices.setAdditionalVariableActiveInactive(params);
    if (res && res?.code === 200) {
      toasterMsg(transactionMsg('ADDITIONAL_VARIABLES_MASTER.STATUS_UPDATED'), 'success');
      return res;
    }
    throw new Error(res?.message || 'Failed to update additional variable status');
  } catch (error) {
    console.log(error?.message);
    toasterMsg(error?.message || ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const getAdditionalVariablesByProduct = (params) => async () => {
  try {
    const res = await SystemMasterServices.getAdditionalVariablesByProduct(params);
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.data?.data)) return res.data.data;
    return res?.data ?? res;
  } catch (error) {
    console.error('Error in getAdditionalVariablesByProduct:', error);
    throw error;
  }
};

/**
 * Backend message keys for the Length master whose i18n strings carry a `{{name}}` placeholder for
 * the tenant-renameable Variable 1 label (Company.variableOneName, e.g. "Lengths-New"). The word
 * "Lengths" is no longer hardcoded in the toast, so these keys must be resolved with the name.
 */
const LENGTH_MASTER_MESSAGE_KEYS = [
  'BACKEND_SERVICE.LENGTH_ACTIVATED',
  'BACKEND_SERVICE.LENGTH_DEACTIVATED',
  'BACKEND_SERVICE.LENGTH_ADDED',
  'BACKEND_SERVICE.LENGTH_DELETED',
  'BACKEND_SERVICE.LENGTH_UPDATED_SUCCESSFULLY',
];

/**
 * Resolves a `MASTERS.<messageKey>` toast, interpolating the dynamic Length label for Length master
 * messages and falling back to "Lengths" when no custom name is set. Non-Length messages resolve
 * unchanged, so shared actions can call this for every master without special-casing each one.
 * @param {(key: string, options?: object) => string} transactionMsg The i18n translator.
 * @param {string} messageKey The backend message key returned in the response.
 * @param {string} [masterName] The tenant's Variable 1 name for the Length master.
 * @returns {string} The resolved toast text.
 */
const resolveMasterMessage = (transactionMsg, messageKey, masterName) => {
  if (LENGTH_MASTER_MESSAGE_KEYS.includes(messageKey)) {
    return transactionMsg(`MASTERS.${messageKey}`, { name: masterName?.trim() || 'Lengths' });
  }
  return transactionMsg(`MASTERS.${messageKey}`);
};
/**
 * Fetches product types for the System Masters admin screens, which legitimately need tiers other
 * than Tier 1 — every tier for the user-document master, or one chosen tier for the product-type
 * master. Writes to `pcTypeAdminList` rather than `pcTypeList` so an all-tier or non-Tier-1 payload
 * can never reach the Tier-1 dropdowns the rest of the app reads (BM-9834).
 * @param {object} params - Query parameters forwarded to the supplier-type master.
 * @param {boolean} isFromSystemMaster - Flags the request as originating from System Masters.
 */
export const getPCTypesAdminDetails = (params, isFromSystemMaster) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllPCTypes(params, isFromSystemMaster);
    await dispatch({
      type: t.GET_ALL_PC_TYPE_ADMIN,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

const HTTP_CONFLICT = 409;
/**
 * Fetches one Category 3 or Category 4 list for a System Masters card that keeps the list to
 * itself. Nothing is written to `category3List` / `category4List`: every card on the page and
 * every filter in the app reads those shared keys, so one card's selection would otherwise
 * repopulate another card's dropdowns and rows (BM-9833).
 * @param {object} params - Query forwarded to the category endpoint; `categoryType` picks 3 or 4.
 * @returns {Promise<Array<object>>} The categories, or an empty list when the request fails.
 */
export const getCategoryListForMasterCard = (params) => async () => {
  try {
    const res = await MASTER_CARD_CATEGORY_SERVICES[params.categoryType](params);
    return res?.data || [];
  } catch (error) {
    console.log(error?.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
    return [];
  }
};

const MASTER_CARD_CATEGORY_SERVICES = {
  3: SystemMasterServices.getAllCategory3,
  4: SystemMasterServices.getAllCategory4,
};
/**
 * Load the type-based options of several category levels with one request to the existing
 * fetch-type-based-category endpoint: an array `categoryType` makes its query match every level at
 * once. The name-sorted rows are split by their `type` into each level's store key, exactly as
 * getTypeBasedCatgeory fills it for a single level; a level with no categories gets an empty list.
 * @param {number[]} categoryTypes - The category levels to load.
 * @param {boolean} isActive - When true, only active categories.
 * @returns {function(Function): Promise<void>} A thunk that settles once every level's options are in the store.
 */
export const getTypeBasedCategories = (categoryTypes, isActive) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getTypeBasedCatgeory({ categoryType: categoryTypes, isActive });
    if (res?.code !== 200) return;
    const categories = Array.isArray(res.data) ? res.data : [];
    categoryTypes.forEach((categoryType) =>
      dispatch({
        type: t.FETCH_TYPE_BASED_CATEGORY,
        payload: { data: categories.filter((category) => Number(category.type) === Number(categoryType)), categoryType },
      }),
    );
  } catch {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Fetches the seasons a list-page filter offers into `filterSeasonList`, its own key. Filters
 * search by every season, inactive ones included, while Add/Edit screens load active-only
 * seasons into `seasonList`; sharing one key let whichever request finished last decide what
 * the other screen showed.
 * @param {object} [params] - Query forwarded to the seasons endpoint.
 * @returns {Promise<Array<object>|undefined>} The seasons, or undefined when the request fails.
 */
export const getFilterSeasonsDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSeasons(params);
    dispatch({
      type: t.GET_FILTER_SEASONS,
      payload: res.data,
    });
    return res.data;
  } catch {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return undefined;
  }
};
const SYSTEM_MASTER_NAMESPACE = 'systemMaster';

/**
 * Toasts a System Masters write the server rejected. A 4xx carries a translation key, such as the
 * CUSTOM_ATTRIBUTES.ACTION_NOT_PERMITTED a refused right answers with; it is looked up in the
 * caller's namespace first and then in systemMaster. A failure with no key, or a key with no
 * translation in either, shows the generic message, so the raw key never reaches the user.
 * @param {Function} transactionMsg - The caller's i18n translator.
 * @param {unknown} error - The rejected API call.
 * @returns {void}
 */
const toastMasterWriteError = (transactionMsg, error) => {
  const errorKey = getApiErrorKey(error);
  const translate = typeof transactionMsg === 'function' ? transactionMsg : null;
  const callerMessage = backendErrorMsg(translate, errorKey);
  const systemMasterMessage = backendErrorMsg(translate && ((key) => translate(key, { ns: SYSTEM_MASTER_NAMESPACE })), errorKey);
  toasterMsg(callerMessage === ERROR_MESSAGE ? systemMasterMessage : callerMessage, 'danger');
};
/** Prefix of a translatable server message key, as opposed to free text. */
const BACKEND_SERVER_KEY_PREFIX = 'BACKEND_SERVER.';

/** Namespace holding the partner-overview server message keys. */
const PARTNER_OVERVIEW_NAMESPACE = 'modules/partner-overview';
